import TRUNCATE_UNITS from '@/utils/enum/TRUNCATE_UNITS';
import {
  formatNumberToCurrency,
  presentNumberToCurrencyTable
} from '@/services/formatter_services/currency-formatter';
import dateFormatter from '@/services/formatter_services/date-formatter';

const INVOICE_WIDGETS = Object.freeze({
  INVOICE_WIDGETS: [
    {
      id: 'invoice',
      path: 'payments',
      getData: response => response.data.data?.map(item => item.data),
      headers: [
        {
          text: 'Common.company',
          value: 'companyName',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 20
        },
        {
          text: 'Common.matchcode',
          value: 'matchCode',
          truncateUnit: TRUNCATE_UNITS.STRING,
          truncateAfter: 15
        },
        {
          text: 'Dashboard.widgets.invoice.headers.from',
          value: 'from',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        {
          text: 'Dashboard.widgets.invoice.headers.cashDiscountDeadline',
          value: 'cashDiscountDeadline',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        {
          text: 'Dashboard.widgets.invoice.headers.maturityDate',
          value: 'maturityDate',
          presentWith: dateFormatter.formatDateToLocaleDateStringNoTime
        },
        {
          text: 'Dashboard.widgets.invoice.headers.referenceNumber',
          value: 'referenceNumber'
        },
        {
          text: 'Dashboard.widgets.invoice.headers.status',
          value: 'status'
        },
        {
          text: 'Dashboard.widgets.invoice.headers.direction',
          value: 'direction'
        },
        {
          text: 'Common.gross',
          value: 'totalGrossSum',
          presentWith: presentNumberToCurrencyTable,
          alignValue: 'right',
        },
        {
          text: 'Common.net',
          value: 'totalNetSum',
          presentWith: presentNumberToCurrencyTable,
          alignValue: 'right',
        },
        {
          text: 'Dashboard.widgets.invoice.headers.calculatedPaid',
          value: 'calculatedPaid'
        },
        {
          text: 'Dashboard.widgets.invoice.headers.calculatedOutstanding',
          value: 'calculatedOutstanding',
          presentWith: presentNumberToCurrencyTable,
          alignValue: 'right',
        }
      ],
      type: 'TABLE',
      moduleId: 'invoices',
      withRouterActionLink: true
    },
    {
      id: 'invoiceNetSum',
      path: 'payments',
      type: 'VALUE',
      presentWith: formatNumberToCurrency,
      alignValue: 'right',
      getData: response => response.data.aggregations.totalNetSum,
      moduleId: 'invoices'
    },
    {
      id: 'invoiceGrossSum',
      path: 'payments',
      type: 'VALUE',
      presentWith: formatNumberToCurrency,
      alignValue: 'right',
      getData: response => response.data.aggregations.totalGrossSum,
      moduleId: 'invoices'
    },
    {
      id: 'invoiceNetSumByMonth',
      moduleId: 'payments',
      path: 'reports/sales-statistics',
      type: 'CHART',
      getData: response => ({items: response.data.data}),
      defaultChartType: 'LINE',
      metric: 'netAmount',
      legendLabel: 'month',
      presentWith: formatNumberToCurrency,
      mapSuffix: presentNumberToCurrencyTable,
      suffix: 'netAmount',
      defaultFilter: {
        groupByMonth: true,
        columns: 'month,netAmount',
        accountingMode: 'sales'
      },
      mapAdditionalFilters: filters => {
        if (!filters)
          return {};

        return {
          from: filters.fromDate,
          until: filters.untilDate,
        }
      },
      xAxisLabel: 'Monat',
      yAxisLabel: 'Umsatz [€]',
      hideLegend: true,
    },
    {
      id: 'invoiceOutstandingByCustomer',
      moduleId: 'payments',
      path: 'payments',
      type: 'CHART',
      getData: response => ({items: response.data.data}),
      defaultChartType: 'BAR',
      metric: 'totalNetSum',
      legendLabel: 'customer',
      presentWith: formatNumberToCurrency,
      mapSuffix: presentNumberToCurrencyTable,
      suffix: 'totalNetSum',
      defaultFilter: {
        groupByCustomer: true,
        paymentType: 'OVERDUE',
        size: 10,
        sort: 'calculatedOutstanding:desc',
        columns: 'customer,totalNetSum',
      },
      mapAdditionalFilters: filters => {
        if (!filters)
          return {};

        return {
          from: filters.fromDate,
          until: filters.untilDate,
        }
      },
      xAxisLabel: 'Kunde',
      yAxisLabel: 'Rechnungsbetrag [€]',
      hideLegend: true,
    }
  ]
});

export default INVOICE_WIDGETS;
